import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import SectionPanel from 'components/organisms/SectionPanels/SectionPanel/SectionPanel';

const StyledCollectionSourcesSectionPanel = styled(SectionPanel)`
  &.CollectionSourcesSectionPanel {
    .SectionPanel-panel {
      padding: 0;
      height: unset;
      overflow: hidden;
    }
  }
  
  ${ComponentStyles}
`;

StyledCollectionSourcesSectionPanel.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionSourcesSectionPanel;
